package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CancelSubscriptionRequest(
    @SerialName("subscriptionId") val subscriptionId: String
)